import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Login pages: a restored session must land on the app, not on the sign-in form.
export const GuestRoute = ({ children, to = "/" }) => {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user)
    return <Navigate to={["super_admin", "platform_admin"].includes(user.role) ? "/platform" : to} replace />;
  return children;
};
